import { render } from "./AverageCFUCompletion.vue?vue&type=template&id=a8208210"
import script from "./AverageCFUCompletion.vue?vue&type=script&lang=js"
export * from "./AverageCFUCompletion.vue?vue&type=script&lang=js"
script.render = render

export default script